<template>
  <div class="app">
    <RouterView />
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {

  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Dosis:wght@300;400;500;600;700&display=swap');


body {
  margin: 0;
  padding: 0;
  width: 100vw;
  overflow: auto;
  font-family: 'Dosis', sans-serif;
  font-size: 24px;
  overflow-x: hidden;
  background:rgba(44,79,121,1);
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #262626;

}

h2 {
  text-align: center;
}

img {
  width: 100%;
}

.app {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.wrapper {
  width: 70vw;
  align-self: center;
}

img {
  max-width: 100%;
}

.default-link {
  color: #2b4e79;
  border-bottom: 1px solid transparent;
  text-decoration: none;
  transition: border-bottom .3s ease-in-out;
}

.default-link:hover {
  border-color: #2b4e79;
}


.container {
  max-width: calc(100% - 300px);
  box-sizing: border-box;
  @media screen and (max-width: 991px) {
    max-width: none;
  }
  @media screen and (min-width: 1620px) {
    max-width: 1320px;
  }
}

  .logo {
    width: 100px;
    position: fixed;
    z-index: 200;
    top: 30px;
    left: 30px;
    @media screen and (max-width: 991px) {
      left: 50%;
      width: 33%;
      transform: translate(-50%, 0);
      z-index: 0;
    }
  }

  .main-section {
    background: #dcb4ad;
    padding: 30px 0 60px;
    position: relative;
    @media screen and (max-width: 991px) {
      padding: 20px 0 40px;
    }
  }

  .main-section h2 {
    font-size: 56px;
    margin-top: 0;
  }
</style>
